module.exports = __webpack_public_path__ + "static/media/IronMan.207c63cb.png";